import { createAsyncAction } from "../../utils/redux";

export const createQueueAction = createAsyncAction("queue/create");
